var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import { useContext } from 'react';
import { StartChatLink } from '../cbr/eligibility/subcomponents';
import { startChatDataProps } from '../../const/analytics';
import CBRContext from '../cbr/context';
var StartChat = function () {
    var t = useTranslation().t;
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var accountId = useContext(CBRContext).accountId;
    var handleStartChat = function () {
        pointOfNeedChat('CreditBalanceRefund', accountId);
    };
    return (_jsxs(_Fragment, { children: [t('text.requestARefund'), _jsx(StartChatLink, __assign({}, startChatDataProps, { className: "ensightencustomevent", buttonType: "text", "data-cy": "startAChatLink", onClick: handleStartChat }, { children: t('text.startAChat') })), "."] }));
};
export default StartChat;
